// Import controller interfaces
import { IEligibilityMessagePriorityController } from "../Interfaces/ControllerInterfacesBarrel";
// Import api models.
import {
    EligibilityMessagePriority,
    EligibilityMessagePriorityAddRequest,
    EligibilityMessagePriorityWithId,
} from "@app/models/api";

export default class MockEligibilityMessagePriorityController implements IEligibilityMessagePriorityController {

    public constructor() {
    }

    public async addEligibilityMessagePriority(
        elgibilityMessagePriorityAddRequest: EligibilityMessagePriorityAddRequest
    ): Promise<EligibilityMessagePriorityWithId> {

        throw new Error("Method not implemented.");
    }

    public async updateEligibilityMessagePriority(
        eligibilityMessagePriorityId: string,
        eligibilityMessagePriority: EligibilityMessagePriority
    ): Promise<EligibilityMessagePriorityWithId> {
        throw new Error("Method not implemented.");
    }

    public async deleteEligibilityMessagePriority(
        eligibilityMessagePriorityId: string
    ): Promise<void> {
        throw new Error("Method not implemented.");
    }

    public async getEligibilityMessagePriorities(
    ): Promise<EligibilityMessagePriorityWithId[]> {
        throw new Error("Method not implemented.");
    }
}
